import { render, staticRenderFns } from "./pc-render.vue?vue&type=template&id=4685e9bc&"
import script from "./pc-render.vue?vue&type=script&lang=js&"
export * from "./pc-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports